import React, { useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import SubscriptionRow from "../../components/SubscriptionRow";
import {
  fullName,
  getErrorString,
  getUserDetail,
  getUserId,
} from "./../../constants/function";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import ApiService from "./../../services/api-service";
import SuccessPopup from "../../components/SuccessPopup";
import { useTranslation } from "react-i18next";

export default function Subscription() {
  const { t } = useTranslation("common");
  const [message, setMessage] = useState(t("success.message7"));
  const [open, setOpen] = useState(false);

  const userDetails = getUserDetail();
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const userId = getUserId();
  console.log(userId);

  React.useEffect(() => {
    const userIdDirect = localStorage.getItem("userId");
    if (userIdDirect) {
      getSubscriptions(userIdDirect);
    }
  }, []);

  const getSubscriptions = async (id) => {
    try {
      setLoading(true);
      const response = await ApiService.GET_SUBSCRIPTIONS(id);
      setSubscriptions([...response["result"]]);
      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (userDetails["_id"]) {
      getSubscriptions(userDetails["_id"]);
    }
  }, []);

  const unSubscribe = async (artistId, index) => {
    try {
      setLoading(true);
      const response = await ApiService.UNSUBSCRIBE_ARTIST({
        artistId: artistId,
        currency: "siki",
      });
      setMessage(t("success.message4"));
      setOpen(true);
      getSubscriptions(userDetails["_id"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  return (
    <Box
      sx={{
        padding: "20px",
        minHeight: "100vh",
        bgcolor: "var(--background-color, #000)",
        color: "var(--text-primary, #fff)",
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        mb={3}
        sx={{ color: "var(--text-primary, #fff)" }}
      >
        {t("mySubscription.title")}
      </Typography>
      <Stack spacing={2}>
        {subscriptions.length > 0 ? (
          subscriptions.map((subscription, index) => (
            <SubscriptionRow
              key={index}
              title={fullName(subscription["artistDetails"])}
              status={subscription["status"]}
              action={subscription["status"]}
              actionColor={"error"}
              statusColor={"success"}
              data={subscription}
              onAction={(userId, index) => unSubscribe(userId, index)}
              index={index}
            />
          ))
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: "40px 20px",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              background: "rgba(255, 255, 255, 0.05)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="normal"
              sx={{ color: "var(--text-primary, #fff)" }}
              mb={1}
            >
              {t("You Have Not Subscribed To Any Users Yet")}
            </Typography>


          </Box>
        )}
      </Stack>
      {open && (
        <SuccessPopup
          message={message}
          open={open}
          handleClose={() => setOpen(false)}
        />
      )}
      {loading && <Loader />}
    </Box>
  );
}
